import { config } from "./config";
import axios from "axios";
import utils from "../utils";

let calenderApi = {};

calenderApi.getCalenderData = (date) => {
  return axios.post(`${config.url}/widgets/${utils.fetchVariable("current_team")}/calender`, {date}, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

calenderApi.getKnowledgeBase = () => {
  return axios.get(`${config.url}/widgets/knowledge-base`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

export default calenderApi;
